<template>
    <div v-loading="loading" style="display: flex; flex-direction: column; align-items: center;">
        <div style="background: rgba(9, 132, 227, 0.2); width: 100%; margin-bottom: 20px;" class="clearfix">
            <h2 style="color: rgb(9, 132, 227); font-weight: bold; padding: 0px 20px;">
                <span style="cursor: pointer;" @click="$router.go(-1)"><font-awesome-icon
                        :icon="['fas', 'house']" /></span> <font-awesome-icon :icon="['fas', 'chevron-right']" />
                Panel de firmas
            </h2>
        </div>
        <el-input placeholder="Escribe para buscar..." v-model="inputbuscarfirmas"
            style="width:90%; margin-bottom: 20px;"></el-input>
        <div style="max-height: calc(100vh - 170px);  overflow-y: auto; width: 90%;">
            <table style="width:100%">
                <thead style="position:sticky; top:0px;">
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Archivo</th>
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Fecha</th>
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Destinatario</th>
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Empresa</th>
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Estado</th>
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Motivo</th>
                    <th style="background:rgb(9, 132, 227); color:white; padding: 10px;">Acciones</th>
                </thead>
                <tbody>
                    <tr v-for="firma in firmasCalculadas" :key="'firma' + firma.id">
                        <td style="padding: 10px;">{{ firma.nombreDocumento }}</td>
                        <td style="padding: 10px;">{{ formatearFecha(firma.fecha)
                            }}
                        </td>
                        <td style="padding: 10px;">{{ firma.destinatario }}</td>
                        <td style="padding: 10px;">{{ firma.empresa }}</td>
                        <td :style="`padding: 10px; background: ${calcularEstado(firma)}`">
                            {{ firma.estadoFirmado }}</td>
                        <td style="padding: 10px;">{{ firma.motivo_rechazo }}</td>
                        <td style="display:flex; width:100% ">
                            <el-tooltip content="Recuperar documento" placement="top" effect="dark"><el-button
                                    @click="recuperarDocumento(firma.idDocumento)" type="primary" plain><el-icon>
                                        <Document size="large" />
                                    </el-icon></el-button>
                            </el-tooltip>
                            <el-tooltip content="Información" placement="top" effect="dark">
                                <el-button style="margin: 0px;" @click="infoDocumento(firma)" type="primary" plain><el-icon>
                                        <InfoFilled size="large" />
                                    </el-icon></el-button>
                            </el-tooltip>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { ElMessageBox } from 'element-plus'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
import moment from 'moment';
export default {
    name: 'SeguimientoDocumentos',
    data() {
        return {
            loading: true,
            cargando: false,
            shake: false,
            panelfirmas: [],
            inputbuscarfirmas: '',
        }
    },
    mounted() {
        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
        this.loading = true;
        this.obtenerDatosFirma();
        this.loading = false;
    },
    watch: {
        numIndices() {
            this.selectorzip = false;
            this.obtenerDocumentos(this.usuarioSeleccionado.email);
        }
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'datos', 'firmas'
        ]),
        firmasCalculadas() {
            let panelfirmas = [...this.panelfirmas];
            if (this.inputbuscarfirmas != '') {
                let input = this.inputbuscarfirmas;
                console.log(input);
                panelfirmas = panelfirmas.filter((firma) => { return firma.nombreDocumento.toLowerCase().includes(input.toLowerCase()) || firma.destinatario.toLowerCase().includes(input.toLowerCase()) || firma.empresa.toLowerCase().includes(input.toLowerCase()) || firma.estadoFirmado.toLowerCase().includes(input.toLowerCase()) || firma.usuario.toLowerCase().includes(input.toLowerCase()) })
            } else {
                panelfirmas = panelfirmas.slice(0, 500);
            }
            return panelfirmas;
        },
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setFirmas'
        ]),
        async infoDocumento(doc) {
            let evidences = {
                EMAIL_SENT: 'Email enviado',
                EMAIL_OPENED: 'Email abierto',
                EMAIL_CLICKED: 'Click en el email',
                OTP_SENT: 'SMS Enviado',
                OTP_VERIFIED: 'SMS Validado',
                DOC_SIGNED: 'Documento firmado',
                DOC_REJECTED: 'Documento rechazado'
            }
            doc.loading = true;
            let resp = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/getInfoDocs', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ signedDocGui: doc.idDocumento })
            })
            if (resp.status) {
                resp = await resp.json();
                let texto = '';
                resp.Signers.forEach((signer) => {
                    texto += `<h3>${signer.SignerName}</h3>
                  <p><b>Estado: </b>${signer.SignatureStatus}<br>`;
                    if (signer.SignatureStatus == 'Rejected') {
                        texto += `<b>Motivo de rechazo: </b>${signer.RejectionReason}<br>`;
                    }
                    if (signer.OperationTime != null) {
                        texto += `<b>Fecha de actualización: </b>${signer.OperationTime}<br>`;
                    }
                    if (signer.Evidences != null) {
                        texto += `<b>Evidencias: </b>`;
                        texto += `<ul>`;
                        signer.Evidences.forEach((evidencia) => {
                            texto += `<li>${evidences[evidencia.EvidenceType]}: ${evidencia.EvidenceDate}</li>`
                        })
                        texto += `</ul>`;
                    }
                    texto += '</p>'; // Cerramos el párrafo
                });

                ElMessageBox.alert(texto, 'Información del documento: ' + doc.nombreDocumento, {
                    confirmButtonText: 'OK',
                    dangerouslyUseHTMLString: true,
                });
            }
            doc.loading = false;
        },
        async obtenerDatosFirma() {
            let response = await fetch(process.env.VUE_APP_PORTAL + '/api/firmas/verFirmasTotales', {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                }
            });
            if (response.status == 200) {
                this.setFirmas(await response.json());
                this.setFirmas(this.firmas[0]);
            }
            response = await fetch(process.env.VUE_APP_PORTAL + '/api/firmas/getSignerData', {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                }
            });
            if (response.status == 200) {
                this.panelfirmas = await response.json();
                this.panelfirmas = this.panelfirmas.reverse();
            }
        },
        formatearFecha(fecha) {
            return moment(fecha, 'YYYY-MM-DD').format('L');
        },
        calcularEstado(firma) {
            let regex = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/;
            let doc = '#97d5a0';
            if (firma.estadoFirmado == "Firmado") {
                doc = '#97d5a0';
            }
            else if (firma.estadoFirmado == "Pendiente") {
                if (!regex.test(firma.idDocumento)) {
                    firma.motivo_rechazo = firma.idDocumento;
                    firma.estadoFirmado = "Error";
                }
                else {
                    doc = '#f7b572';
                }
            }
            else if (firma.estadoFirmado == "Caducado") {
                doc = '#c4b197';
            }
            else if (firma.estadoFirmado == "Error") {
                doc = '#ef1f1fb5';
            }
            else {
                doc = '#ed9ba7';
            }
            return doc;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#colderecha {
    * {
        max-width: 360px;
    }
}

.fancybox-bg {
    background: #888;
}

.fancybox-is-open .fancybox-bg {
    opacity: 1;
}

.documento {
    padding: 0 10px;
    line-height: 30px;
    font-size: 1rem;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    height: auto;
    border: none;
    background: none;
    color: dimgray;
    text-align: left;

    &.success {
        color: #67C23A;
    }

    &.error {
        color: #f56c6c;
    }
}

.usuario {
    border: 2px solid #0984e3;
    padding: 15px;
    border-radius: 10px;
    color: #0984e3;
    background-color: #0985e31f;
    font-weight: bold;
    margin: 10px;
    transition: 0.5s;
    display: flex;
    align-items: center;

    &:hover {
        background-color: #6dff4005;
    }

    img {
        margin-right: 10px;
    }
}

ul {
    padding-left: 0px;
    padding: 10px;
}

li {
    list-style: none;
    margin: 5px 0px;
}

.contenedorreceptores {
    @media(min-width: 480px) {
        width: 400px;
    }

    height: 50vh;
    overflow-y:auto;
}

.contenedorbusqueda {
    @media(min-width: 480px) {
        width: 400px;
    }
}

.documento {
    padding: 0 10px;
    line-height: 30px;
    font-size: 1rem;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    height: auto;
    border: none;
    background: none;
    color: dimgray;
    text-align: left;

    &.success {
        color: #67C23A;
    }

    &.error {
        color: #f56c6c;
    }
}

.solicitarArchivo {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    margin: 50px 0 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    &.dragover {
        border-color: #0984e3;

        svg {
            color: #0984e3;
        }
    }

    &.apply-shake {
        border-color: #d63031;

        svg {
            color: #d63031;
        }
    }

    svg {
        font-size: 67px;
        color: #C0C4CC;
        line-height: 50px;
        margin-bottom: 10px;
        transition: 0.5s;
    }
}

.el-tag {
    span {
        text-overflow: ellipsis !important;
        overflow: hidden !important;
    }
}

tr:nth-child(even) {
    background-color: #f2f2f2;
}
</style>